import Vue from 'vue'
import packageInfo from '../../package.json'
import App from './App.vue'
import '../registerServiceWorker'
import store from '../store'
import router from '../router'
import vuetify from './plugins/vuetify'

console.info(`UMG Community Playlists V2 version: ${packageInfo.version}`)

Vue.config.productionTip = false

const create = (obj: Record<string, unknown>): Vue => new Vue(obj)

create({
  vuetify,
  el: '#app',
  router,
  components: { App },
  store,
})
